import { CSSProperties, ReactNode } from 'react';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Button from '@mui/material/Button';

interface Props {
    slideNumber: number;
    slideCount: number;
    previousClick?: () => void;
    nextClick?: () => void;
    headerText?: string;
    eventLogoUrl?: string | null;
    children: ReactNode;
    backgroundStyles: CSSProperties;
    fontStyles: CSSProperties;
}

export const Slide = (props: Props) => {
    return (
        <div className="slides-wrapper row" style={props.backgroundStyles}>
            {!!props.previousClick && (
                <Button className="slide-button left" onClick={props.previousClick}>
                    <KeyboardArrowLeftIcon fontSize="large" />
                </Button>
            )}
            <div className="slide-question" style={props.fontStyles}>
                <div className="slide-header">{props.headerText}</div>
                {props.children}
                <div className="slide-footer">
                    <div className="slide-footer-left">
                        {!!props.eventLogoUrl && <img src={props.eventLogoUrl} className="footer-logo" alt="event logo" />}
                    </div>
                    <div className="slide-footer-right">{`${props.slideNumber} / ${props.slideCount}`}</div>
                </div>
            </div>
            {!!props.nextClick && (
                <Button className="slide-button right" onClick={props.nextClick}>
                    <KeyboardArrowRightIcon fontSize="large" />
                </Button>
            )}
        </div>
    );
};
